export function getNumberOfUnpaidRespondents(userSignupItem) {
  if (!userSignupItem || userSignupItem.respondents?.length === 0) return 0;

  try {
    return userSignupItem?.respondents?.filter(
      (r) => r.paymentStatus === "Unpaid"
    ).length;
  } catch (e) {
    return 0;
  }
}
